import { Form } from 'antd';
import { useContext, useEffect, useState } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import InputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import AddSelectML from '@/components/select_ml/add_select_ml/AddSelectML';
import Loading from '@/components/Loading';
// import responseMsgTips from '@/utils/responseMsgTips';
import styles from './add.less?modules';
import { useSelector } from 'dva';
import { FunctionContext } from '../../../index';
import { message } from 'antd';
import { useDispatch } from 'dva';

const Add = (props) => {
  const [options, setOptions] = useState([]);
  const [decisionOption, setDecisionOption] = useState([]);
  const [editionOption, setEditionOption] = useState({});
  const [form] = Form.useForm();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['dvm/addDiagramVersion'];
  const { handleCancel } = props;
  const { fetchData } = useContext(FunctionContext);
  const dispatch = useDispatch();
  // 发起请求
  const onFinish = (values) => {
    addSingleDiagram(values);
  };
  const addSingleDiagram = (value, id) => {
    dispatch({
      type: 'dvm/addDiagramVersion',
      payload: {
        values: {
          ...value,
        },
        id,
      },
      callback: (res) => {
        if (res.message) {
          message.error(res.message);
        } else {
          message.success('新增成功');
          fetchData();
          handleCancel();
        }
      },
    });
  };

  const queryDiagramVersion = () => {
    dispatch({
      type: 'dvm/queryDiagramVersion',
      payload: {},
      callback: (res) => {
        console.log(res);
        let decisionName = [];
        let decisionOptionUnuse = [];
        let editionUnuse = {};
        res.forEach((item) => {
          if (decisionName.indexOf(item.name) === -1) {
            decisionName.push(item.name);
            decisionOptionUnuse.push({
              value: item.name,
              name: item.name,
            });
            editionUnuse[item.name] = [
              { value: item.version, name: item.version },
            ];
          } else {
            editionUnuse[item.name].push({
              value: item.version,
              name: item.version,
            });
          }
        });
        setDecisionOption(decisionOptionUnuse);
        setEditionOption(editionUnuse);
      },
    });
  };

  const onSelect = (e) => {
    for (const key in editionOption) {
      if (e === key) {
        setOptions(editionOption[key]);
      }
    }
  };

  // 发起请求
  useEffect(() => {
    queryDiagramVersion();
  }, []);

  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 决策图 */}
          <AddSelectML
            labelVal="决策图"
            placeVal="请选择决策图"
            name="name"
            required={[
              {
                required: true,
                message: '请选择决策图',
              },
            ]}
            height="47px"
            labelwidth="130px"
            option={decisionOption}
            onSelect={onSelect}
          />
          {/* 基础版本 */}
          <AddSelectML
            labelVal="基础版本"
            placeVal="请选择基础版本"
            name="baseVersion"
            required={[
              {
                required: true,
                message: '请选择基础版本',
              },
            ]}
            height="47px"
            labelwidth="130px"
            option={options}
          />

          {/* 版本号 */}
          <InputML
            labelVal="版本号"
            placeVal="请输入版本号"
            name="version"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入版本号',
              },
            ]}
          />
          {/* 版本描述 */}
          <InputML
            labelVal="版本描述"
            placeVal="请输入版本描述"
            name="description"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入版本描述',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            // htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default Add;
